import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import ProfileStore from '@/stores/ProfileStore';

import LiveChatIcon from './LiveChatIcon';
import ChatIcon from './ChatIcon';
import PhoneIcon from './PhoneIcon';
import EmailIcon from './EmailIcon';
import { ReactComponent as ILFlagIcon } from '@/img/contact_us_page/il-flag.svg';
import { ReactComponent as UKFlagIcon } from '@/img/contact_us_page/uk-flag.svg';
import { ReactComponent as USFlagIcon } from '@/img/contact_us_page/us-flag.svg';
import { ReactComponent as PHFlagIcon } from '@/img/contact_us_page/ph-flag.svg';

const getFlagIconByPhoneNumber = (tel) => {
	if (tel.startsWith('+44')) return <UKFlagIcon />;
	if (tel.startsWith('+1')) return <USFlagIcon />;
	if (tel.startsWith('+63')) return <PHFlagIcon />;
	if (tel.startsWith('+972') || tel.startsWith('03')) return <ILFlagIcon />;
};

const getPhoneCardContent = ({ t }) => {
	const supportPhoneNumber = t('SupportPhoneNumber');

	const phoneNumbers = [t('ILPhone'), t('UKPhone'), t('USPhone'), t('PHPhone')].filter((tel) => tel?.trim());

	if (phoneNumbers.length == 0 && supportPhoneNumber) {
		phoneNumbers.push(supportPhoneNumber);
	}

	return (
		<div className="phone-content">
			{phoneNumbers.map((phoneNumber, index) => (
				<div key={index} className="phone-content__item">
					{getFlagIconByPhoneNumber(phoneNumber)}
					<a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
				</div>
			))}
		</div>
	);
};

const getChatCardContent = ({ t }) => {
	const [isChatOpen, setIsChatOpen] = useState(false);

	useEffect(() => {
		if (window.zE) {
			window.zE('messenger:on', 'open', () => setIsChatOpen(true));
			window.zE('messenger:on', 'close', () => setIsChatOpen(false));
		}
	}, []);

	const toggleChat = () => {
		if (window.zE) {
			isChatOpen ? window.zE('messenger', 'close') : window.zE('messenger', 'open');
		}
	};

	return (
		<div className="chat-content">
			<button className="live-chat" onClick={toggleChat}>
				<LiveChatIcon />
				{t('LiveChat')}
			</button>
		</div>
	);
};

const getEmailCardContent = (email) => {
	return (
		<div className="email-content">
			<a href={`mailto:${email}`} target="_blank" rel="noreferrer">
				{email}
			</a>
		</div>
	);
};

const ContactCard = ({ icon, title, content }) => {
	return (
		<div className="contact-card">
			{icon}
			<div className="contact-card-title">{title}</div>
			<div className="contact-card-content">{content}</div>
		</div>
	);
};

const ContactUsPage = ({ t }) => {
	const profile = ProfileStore.getProfile();
	const isChatEnabled = _.get(profile, 'chat_enabled', false);
	const showPhoneCard = t('SupportPhoneNumber') || t('ILPhone') || t('UKPhone') || t('USPhone') || t('PHPhone');
	const HelpEmail = t('HelpEmail');

	return (
		<div className="contact-us-page">
			<div>
				<h1 className="title">{t('ContactUsTitle')}</h1>
				<div className="text">{t('ContactThroughOurChannels')}</div>
			</div>
			<div className="contact-methods">
				{showPhoneCard && (
					<ContactCard
						icon={<PhoneIcon />}
						title={t('CallOurCenters')}
						content={getPhoneCardContent({ t })}
					/>
				)}
				{isChatEnabled && (
					<ContactCard
						icon={<ChatIcon />}
						title={t('ChatOnOurPlatform')}
						content={getChatCardContent({ t })}
					/>
				)}
				{HelpEmail && (
					<ContactCard icon={<EmailIcon />} title={t('EmailUsAt')} content={getEmailCardContent(HelpEmail)} />
				)}
			</div>
			<div className="team-available-text">{t('OurServiceTeam')}</div>
		</div>
	);
};

export default withTranslation()(ContactUsPage);
